<template>
  <div id="app">
    <transition :name="currentTransition" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentTransition: 'fade'
    }
  },
  created() {
    // 初始化全局数据
    if (!this.$root.$data.globalData) {
      this.$root.$data.globalData = {}
    }
  },
  methods: {
    // 设置过渡效果的方法
    setTransition(name) {
      this.currentTransition = name
    }
  },
  watch: {
    '$route'(to, from) {
      // 根据路由深度自动设置过渡效果
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      
      if (toDepth < fromDepth) {
        this.currentTransition = 'slide-right'
      } else if (toDepth > fromDepth) {
        this.currentTransition = 'slide-left'
      } else {
        this.currentTransition = 'fade'
      }
    }
  }
}
</script>

<style>
body {
    margin: 0;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* 过渡效果 - 淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 过渡效果 - 向左滑动（类似Android页面切换） */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-left-enter {
  transform: translate(100%, 0);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translate(-100%, 0);
  opacity: 0;
}

/* 过渡效果 - 向右滑动 */
.slide-right-enter {
  transform: translate(-100%, 0);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translate(100%, 0);
  opacity: 0;
}
</style> 